// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SqkN","right":"styles_right__2T1z8"};